import { createBrowserRouter } from "react-router-dom";
import App from "App";
import { ErrorBoundary } from "app/components/errorBoundary";

export const router = createBrowserRouter([
  {
    path: "/:checkoutRequestId",
    element: <ErrorBoundary><App /></ErrorBoundary>,
  },
]);
